module.exports = __webpack_public_path__ + "res/19-img_bg_l.b72c06ba7b9e91c4a59ce6a3819ab174.png";